import React from 'react';
import {Checkbox} from 'antd';
import classes from './ScheduleFiltersDesktop.module.scss';
import WeekFilters from "../WeekFilters/WeekFilters";
import SubgroupFilters from "../SubgroupFilters/SubgroupFilters";
import {ViewOption} from "../../CommonSchedule/ScheduleView";


const ScheduleFiltersDesktop = ({ viewMode, lessonType, isCurrentPeriod, subgroupFilters, showTodayAndTomorrowFilter,
                                    passedLessonsFilter, sessionFilter, setFilter, defaultWeek, scheduleType }) => {

    const setPassedLessonsFilterCheckbox = (shortenedLabel) => {
        return <Checkbox
            checked={passedLessonsFilter}
            onChange={(e) => setFilter(e.target.checked, "passedLessonsFilter")}>
            {shortenedLabel ? 'Показать прошедшие' : 'Показать прошедшие занятия'}
        </Checkbox>;
    }

    const setSessionFilterCheckbox = (shortenedLabel) => {
        return <Checkbox
            checked={sessionFilter}
            onChange={(e) => setFilter(e.target.checked, "sessionFilter")}>
            {shortenedLabel ? 'Показать' : 'Показать сессию'}
        </Checkbox>;
    }

    const setTodayTomorrowFilterCheckbox = () => {
        return <Checkbox
            checked={showTodayAndTomorrowFilter}
            onChange={(e) => setFilter(e.target.checked, "showTodayAndTomorrowFilter")}>
            Показать сегодня/завтра
        </Checkbox>;
    }

    const getAdditionalFilters = () => {
        const getFiltersElement = (includeLabel, type) => (<React.Fragment>
            <div className={(type === 'exams' || !isCurrentPeriod) ? classes.removed : null}>
                {includeLabel &&
                <div className={classes.filterLabel}>Занятия</div>}
                {setPassedLessonsFilterCheckbox(includeLabel)}
            </div>
            <div className={type === 'exams' ? classes.removed : null}>
                {includeLabel &&
                <div className={classes.filterLabel}>Сессия</div>}
                {setSessionFilterCheckbox(includeLabel)}
            </div>
            {viewMode === ViewOption.List &&
            <div>{setTodayTomorrowFilterCheckbox()}</div>}
        </React.Fragment>);

        return (<div className={`${classes.additionalFilters} ${viewMode === ViewOption.Table ? classes.tableView : null}`}>
            {getFiltersElement(viewMode === ViewOption.Table, lessonType)}
        </div>);
    }

    const getContainerClass = () => {
        return viewMode === ViewOption.List ? classes.listView : classes.tableView;
    }

    return (<div className={`${classes.container} ${getContainerClass()}`}>
        {lessonType !== 'exams' &&
        <div>
            <div className={classes.filterLabel}>Недели</div>
            <div style={{display: 'flex', flexWrap: 'wrap', rowGap: '8px'}}>
                <WeekFilters defaultWeek={defaultWeek} />
            </div>
        </div>}
        {(lessonType !== 'exams' && scheduleType !== 2) &&
        <div>
            <div className={classes.filterLabel}>Подгруппы</div>
            <div>
                <SubgroupFilters setFilter={setFilter}
                                 subgroupFilters={subgroupFilters} />
            </div>
        </div>}

        {getAdditionalFilters()}
    </div>);
}

export default ScheduleFiltersDesktop;
